import { render, staticRenderFns } from "./tbmRiskHazard.vue?vue&type=template&id=77654b88"
import script from "./tbmRiskHazard.vue?vue&type=script&lang=js"
export * from "./tbmRiskHazard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77654b88')) {
      api.createRecord('77654b88', component.options)
    } else {
      api.reload('77654b88', component.options)
    }
    module.hot.accept("./tbmRiskHazard.vue?vue&type=template&id=77654b88", function () {
      api.rerender('77654b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/tbmRiskHazard.vue"
export default component.exports